import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@wb/core/pipes/date.pipe';
import { StatusData } from '../../../core/interfaces/status-data';

enum LeadOrigin {
  WEBSITE = 'website',
  SHOWROOM = 'showroom',
}

enum TradeStatus {
  EXISTS = 'exists',
  SUBMITTED = 'submitted',
  VIEWED = 'viewed',
  DECLINED = 'declined',
  ACCEPTED = 'accepted',
}

enum LoanStatus {
  PARTIAL = 'partial',
  SUBMITTED = 'submitted',
  OFFERED = 'offered',
  VIEWED = 'viewed',
  ACCEPTED = 'accepted',
}

interface IStatus {
  leadOrigin?: LeadOrigin;
  tradeStatus?: TradeStatus;
  loanStatus?: LoanStatus;
  scheduledAppointment?: boolean;
  submittedDeposit?: boolean;
  claimed?: string;
  prequalSubmitted?: boolean;
  prequalCompleted?: boolean;
  chatPartnerEventTimestamp?: string;
  hasNoAssignedSalesperson?: boolean;
  accessoriesAdded?: boolean;
  protectionProductAdded?: boolean;
}

@Component({
  selector: 'app-status-icons',
  templateUrl: './status-icons.component.html',
  styleUrls: ['./status-icons.component.sass'],
})
export class StatusIconsComponent implements OnInit {
  constructor(public datePipe: DatePipe) {}

  @Input() statusData: StatusData | undefined;

  statusIcons: IStatus | undefined;

  date?: string;

  ngOnInit(): void {
    const lead = this.statusData;

    if (lead) {
      // Load Status
      const loanStatus = () => {
        const date = lead?.loanApplicationSubmittedAt;
        this.date = date ? this.datePipe.transform(date, 'MM/DD/YY h:mma') : null;

        if (lead.loanSelected) {
          return LoanStatus.ACCEPTED;
        }
        if (lead.loanOffersViewed) {
          return LoanStatus.VIEWED;
        }
        if (lead.loans !== undefined && lead.loans !== null && lead.loans.length > 0) {
          return LoanStatus.OFFERED;
        }
        if (lead.loanStatus || lead?.loanApplicationSubmittedAt) {
          return LoanStatus.SUBMITTED;
        }
        if (lead.hasFinancialData) {
          return LoanStatus.PARTIAL;
        }
        return;
      };

      const tradeStatus = () => {
        const tradeDecision = lead?.trade?.decision;

        if (tradeDecision !== null && tradeDecision === true) {
          return TradeStatus.ACCEPTED;
        }
        if (tradeDecision !== null && tradeDecision === false) {
          return TradeStatus.DECLINED;
        }
        if (lead?.trade?.tradeOfferViewed === true) {
          return TradeStatus.VIEWED;
        }
        if (lead?.trade?.tradeConfirm === true) {
          return TradeStatus.SUBMITTED;
        }
        if (lead?.tradeExists) {
          return TradeStatus.EXISTS;
        }
        return;
      };

      // Deal Status Icons
      this.statusIcons = {
        leadOrigin: lead.websiteLead ? LeadOrigin.WEBSITE : LeadOrigin.SHOWROOM,
        tradeStatus: tradeStatus(),
        loanStatus: loanStatus(),
        scheduledAppointment: !!lead.scheduleAppointmentAt,
        submittedDeposit: !!lead.transactionId,
        claimed: lead.salesperson ?? undefined,
        prequalSubmitted: lead.creditReport,
        prequalCompleted: lead.prequalified,
        chatPartnerEventTimestamp: lead.chatPartnerEventTimestamp,
        hasNoAssignedSalesperson: lead.hasNoAssignedSalesperson,
        accessoriesAdded: lead.accessoriesAdded,
        protectionProductAdded: lead.protectionProductAdded,
      };
    }
  }
}
